var _g, _defs, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 12,
    fill: "var(--color-grey-400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 12,
    fill: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2101_56352",
    transform: "translate(-.155) scale(.00032)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2101_56352",
    result: "effect2_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_2101_56352",
    result: "effect3_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2101_56352",
    result: "shape"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 12.46c-.089-.397-1.335-5.176 1.687-7.001 1.014-.612 1.659-.106 1.659-.106s.224-.584 1.25-.584c6.557 0 5.24 6.684 5.087 7.204-.662 2.244-1.808 4.496-5.002 4.496-3.193 0-4.445-2.953-4.68-4.009z",
    fill: "#8e633f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.023 19.6c-.62-2.212-3.732-1.967-5.075-2.602-1.343-.635-1.133-2.767-1.303-3.138h-3.277c-.17.371.04 2.503-1.304 3.138-1.343.635-4.455.39-5.075 2.602-.342 1.22-.326 1.594-.42 2.946 0 0 4.27.89 8.34.89 4.071 0 8.534-.89 8.534-.89-.094-1.352-.078-1.725-.42-2.946z",
    fill: "#e8c59e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.213 17.485c1.343.636 4.455.39 5.075 2.603.326 1.162.326 1.556.407 2.758 1.07-.165 1.748-.3 1.748-.3-.094-1.352-.078-1.725-.42-2.946-.62-2.212-3.732-1.967-5.075-2.602-1.343-.635-1.133-2.767-1.303-3.138h-1.736s-.04 2.99 1.304 3.625z",
    fill: "#ddb58e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 23.436c2.078 0 4.26-.233 5.896-.46-.02-.374-.092-2.105.285-3.005.547-1.303 1.62-1.052 1.62-1.052-.701-1.03-2.148-1.285-3.366-1.532.784.637 1.287 1.67.606 4.086 0 0-.937-.16-2.157.305-.627.239-1.931.924-2.787.924-.857 0-2.16-.685-2.788-.924-1.22-.465-2.157-.305-2.157-.305-.681-2.415-.178-3.45.606-4.086-1.218.247-2.665.502-3.365 1.532 0 0 1.072-.251 1.619 1.052.382.91.303 2.674.284 3.019 1.577.222 3.665.446 5.704.446z",
    fill: "#515151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.71 18.92c-.7-1.03-2.148-1.286-3.365-1.533.373.303.682.696.83 1.285.434.26.791.613 1.005 1.11.566-1.089 1.53-.863 1.53-.863z",
    fill: "#474747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.927 16.063c.543.467 1.181.93 2.076 1.063.897-.134 1.532-.606 2.077-1.075-.453-.877-.313-1.923-.435-2.191h-3.277c-.123.268.014 1.326-.441 2.203z",
    fill: "#cca281"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0589 0 0 .0586 5.625 4.769)",
    fill: "#f4f4f2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.303,
    cy: 207.332,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.323,
    cy: 214.847,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.613,
    cy: 221.889,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.073,
    cy: 228.25,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.566,
    cy: 233.778,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.943,
    cy: 238.234,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.999,
    cy: 241.513,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.503,
    cy: 243.521,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.263,
    cy: 244.21,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.999,
    cy: 243.537,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.525,
    cy: 241.524,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.572,
    cy: 238.224,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.945,
    cy: 233.754,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.443,
    cy: 228.278,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.911,
    cy: 221.9,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.199,
    cy: 214.835,
    r: 3.187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.202,
    cy: 207.319,
    r: 3.187
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0589 0 0 .0586 5.625 4.769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(100.195 224.157 118.136)",
    cx: 224.155,
    cy: 118.137,
    rx: 21.386,
    ry: 11.629,
    fill: "#ddb58e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(169.801 94.217 118.143)",
    cx: 94.216,
    cy: 118.143,
    rx: 11.629,
    ry: 21.386,
    fill: "#e8c59e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.735 56.161s-65.874-7.487-66.683 11.927c-.793 19.02.124 21.712-.028 26.181-1.551 44.156 7.464 104.645 66.171 113.48 62.979-9.476 68.808-77.969 65.727-122.456-1.533-22.151-65.187-29.132-65.187-29.132z",
    fill: "#e8c59e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.195 207.749c94.331-14.192 60.45-160.806 60.45-160.806h-14.141c3.873 61.242 9.229 93.774-13.006 129.24-17.615 28.104-33.303 31.566-33.303 31.566z",
    fill: "#ddb58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.781 133.782v-75.26H90.843v75.26H98.6c-.68-39.266 27.221-38.423 34.033-60.781 9.69 23.989 35.64 20.139 61.557 48.247 12.146 13.18 16.232 26.248 16.362 37.726h12.23z",
    fill: "#ddb58e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.877 65.289c8.538-26.355 85.04-44.948 85.046-44.948.011 0 57.027 6.885 68.881 31.925 16.39 34.629 11.511 68.622-1.394 99.08-11.719 27.67-34.662 39.271-34.662 39.271s32.706-37.355-2.557-75.609c-25.917-28.109-49.304-18.02-61.557-50.119-8.667 32.099-38.895 23.14-33.415 71.905 6.053 53.823 42.992 74.074 42.992 74.074s-45.398-9.139-62.198-78.211c-9.646-39.692-2.21-64.063-1.136-67.368z",
    fill: "#8e633f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFemale);
export default __webpack_public_path__ + "static/media/color-female.66c1dabb7a12115574b234e3a4efb5d8.svg";
export { ForwardRef as ReactComponent };